<template>
        <v-card class="text-left ma-3">
          <v-card-title style="word-break: normal;">
            What's Nude @ The Farm
          </v-card-title>
          <v-card-subtitle style="word-break: normal;">
            Follow Sky Farm on Instagram
          </v-card-subtitle>
          <v-card-text>
            <iframe style="border:none;" height="500" width="100%" src="instagram.html"/>
            <hr>
          </v-card-text>
          <v-card-title style="word-break: normal;">
            Be sure to visit us on our Social Media accounts!
          </v-card-title>
          <v-card-text>

            Visit us on our social media pages!  There is lots of
            helpful information there and we would love to see you
            there.  Look for <b>@SkyFarmNJ</b>:

          </v-card-text>
          <v-card-text class="text-center">
            <v-btn
               v-for="(x, i) in socials"
               :key=i
               icon x-large
               @click="callSocial(i)"
               >
              <v-icon x-large >mdi-{{x.icon}}</v-icon>
            </v-btn>
          </v-card-text>
        </v-card>
</template>

<script>
export default {
    data: () => {
        return {
            socials: [
                {url: "https://www.facebook.com/skyfarmnj", icon: "facebook", title: "Facebook", id: "SkyFarmNJ" },
                {url: "https://twitter.com/intent/follow?original_referer=http%3A%2F%2Fwww.skyfarm.com%2F&ref_src=twsrc%5Etfw&region=follow_link&screen_name=SkyFarmNJ&tw_p=followbutton", icon: "twitter", title: "Twitter", id: '@SkyFarmNJ' },
                { url: "https://www.instagram.com/skyfarmnj", icon: "instagram", title: "Instagram", id: "SkyFarmNJ" },
            ]
        }
    },
    methods: {
        callSocial(i) {
            this.$gtag.event('linkto', { event_label: this.socials[i].title });
            window.open(this.socials[i].url, '_blank')
        },
    }
}

</script>